<template>
  <div>
  <v-text-field
    v-if="showRawFallback"
    v-model="field.field"
    :label="field.name"
    outlined
    dense
    maxlength="150"
    persistent-hint
    :hint="$t('customFieldLegacyValueHint')"
  />
  <v-switch
    v-else-if="field.fieldType === 'boolean'"
    v-model="field.field"
    :label="field.name"
    :true-value="'true'"
    :false-value="'false'"
    hide-details
    inset
    class="mt-0"
  />
  <v-menu
    v-else-if="field.fieldType === 'date'"
    v-model="dateMenuOpen"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-model="field.field"
        :label="field.name"
        outlined
        dense
        hide-details
        readonly
        clearable
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      :value="field.field"
      :first-day-of-week="1"
      :locale="$i18n.locale"
      @input="onDatePicked"
    />
  </v-menu>
  <v-select
    v-else-if="field.fieldType === 'select'"
    v-model="field.field"
    :items="selectItems"
    :label="field.name"
    outlined
    dense
    clearable
    hide-details
  />
  <v-text-field
    v-else
    v-model="field.field"
    outlined
    dense
    :label="field.name"
    maxlength="150"
    hide-details
  />
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import { isParsableDate } from '@/utils/customFieldUtils'

export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const dateMenuOpen = ref(false)

    const onDatePicked = (value) => {
      props.field.field = value
      dateMenuOpen.value = false
    }

    // Keep an orphan select value (one removed from options, or left over after
    // a type change) visible and selectable instead of silently dropping it.
    const selectItems = computed(() => {
      const options = props.field.options || []
      const value = props.field.field
      if (value && !options.includes(value)) {
        return [...options, value]
      }

      return options
    })

    // When a stored value cannot be represented by its type-specific input
    // (legacy data after a type change), fall back to an editable text field so
    // the raw value is never hidden from the user.
    const showRawFallback = computed(() => {
      const value = props.field.field
      if (!value) return false
      if (props.field.fieldType === 'boolean') {
        return value !== 'true' && value !== 'false'
      }
      if (props.field.fieldType === 'date') {
        return !isParsableDate(value)
      }

      return false
    })

    return {
      dateMenuOpen,
      onDatePicked,
      selectItems,
      showRawFallback,
    }
  },
}
</script>
